export enum StatusTypes {
  Success = 'Success',
  Failure = 'Failure'
}
